import Modal from './Modal';
import React from 'react';
import { Box, Button, makeStyles, Typography, withStyles } from '@material-ui/core';

import { confirmModalStyles } from './styles';
import { modalsButtonStyles } from '../../collums-constants/styles/stylesheets/buttonsStyles';

const ConfirmModal = ({
    classes,
    onConfirm,
    title,
    content,
    centerContent,
    contentHtml = null,
    setIsOpen,
    isOpen,
    cancelText = 'Cancel',
    continueText = 'Confirm',
    hideCloseIcon = false,
    hideCancelButton = false,
    disableBackdropClick = false,
    onCancel = null
}) => {
    const globalStyles = makeStyles(modalsButtonStyles)();

    const handleClose = (fireOnCancel = true) => {
        if (onCancel && fireOnCancel) {
            onCancel();
        }
        setIsOpen(false);
    };

    return (
        <Modal
            id={title}
            isOpen={isOpen}
            title={title}
            size="xs"
            draggable
            onCancel={handleClose}
            onClose={handleClose}
            dialogClass={classes.modal}
            hideCloseIcon={hideCloseIcon}
            disableBackdropClick={disableBackdropClick}
        >
            <Box container spacing={4}>
                {content ? <Typography align={centerContent ? 'center' : 'inherit'}>{content}</Typography> : ''}
                {contentHtml ? (
                    <Typography
                        align={centerContent ? 'center' : 'inherit'}
                        dangerouslySetInnerHTML={{ __html: contentHtml }}
                    ></Typography>
                ) : (
                    ''
                )}
            </Box>
            <div className={globalStyles.buttonsContainer}>
                {!hideCancelButton && (
                    <Button className={globalStyles.cancelButton} onClick={handleClose}>
                        {cancelText}
                    </Button>
                )}
                <Button
                    className={globalStyles.confirmButton}
                    onClick={() => {
                        onConfirm();
                        handleClose(false);
                    }}
                >
                    {continueText}
                </Button>
            </div>
        </Modal>
    );
};

export default withStyles(confirmModalStyles)(ConfirmModal);
